/**
 * 活动相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/comment/query',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/comment/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/comment/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        removeInfo(data) {
            return http.json({
                url: `/comment/delete?id=${data[0].id}`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/comment.js